<template>
  <div class="confirmContent" id="confirmContent" @click="closeConfirm(opts[0].maskClick)">
    <div class="box">
      <div class="title" v-if="title" v-html="title"></div>
      <div class="contentMess contentmessHtml" v-html="mes"></div>
      <!-- <span @click.stop="closeConfirm(false, opts)">确定</span> -->
      <div class="bottom" v-if="typeof opts == 'function'">
        <span class="cancel" @click.stop="closeConfirm(false)">取 消</span>
        <span class="sure" @click.stop="closeConfirm(false, opts)">确 定</span>
      </div>
      <div class="bottom" v-else>
        <span
          href="javascript:;"
          class="yd-confirm-btn"
          :key="key"
          v-for="(item, key) in opts"
          :class="typeof item.color == 'boolean' ? (item.color ? 'primary' : 'default') : ''"
          :style="{background: item.color}"
          @click.stop="closeConfirm(item.stay, item.callback)"
        >{{item.txt}}</span>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  props: {
    title: String,
    mes: String,
    opts: {
      type: [Array, Function],
      default: () => {}
    }
  },
  created(){

  }
};
</script>
<style lang="less" scoped>
.confirmContent {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 750px;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1601;
  .box {
    background: #fff;
    width: 90%;
    padding: 0.2rem 0.2rem;
    padding-top: 0.5rem;
    border-radius: 0.3rem;
    text-align: center;
    .title {
      color: #000000;
      font-size: 0.34rem;
      padding-bottom: 0.30rem;
    }
    .contentMess {
      font-size: 0.3rem;
      padding: 0 0.20rem;
      p{
        line-height: 1.8 !important;
      }
      white-space: pre-line;
    }
    .bottom {
      padding-top: 0.4rem;
      padding-bottom: 0.2rem;
      span {
        width: 2.2rem;
        height: 0.68rem;
        border-radius: 0.32rem;
        line-height: 0.68rem;
        font-size: 0.32rem;
        display: inline-block;
        color: #fff;
        &:last-child {
          margin-left: 0.5rem;
        }
      }
      .sure {
        color: #fff;
        background: #ffbc00;

        display: inline-block;
      }
      .cancel {
        background: #e6e6e6;
        width: 2.2rem;
        height: 0.68rem;
        border-radius: 0.32rem;
        line-height: 0.68rem;
        font-size: 0.32rem;
        display: inline-block;
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
